import {
  RiFacebookLine,
  RiInstagramLine,
  RiLinkedinLine,
  RiThreadsLine,
  RiTiktokLine,
  RiTwitterLine,
  RiYoutubeLine,
} from "react-icons/ri";

const SOCIAL_PLATFORMS = [
  {
    key: "instagram",
    label: "Instagram",
    icon: RiInstagramLine,
    baseUrl: "https://instagram.com/",
  },
  {
    key: "facebook",
    label: "Facebook",
    icon: RiFacebookLine,
    baseUrl: "https://facebook.com/",
  },
  {
    key: "tiktok",
    label: "TikTok",
    icon: RiTiktokLine,
    baseUrl: "https://tiktok.com/@",
  },
  {
    key: "youtube",
    label: "YouTube",
    icon: RiYoutubeLine,
    baseUrl: "https://youtube.com/@",
  },
  {
    key: "twitter",
    label: "X / Twitter",
    icon: RiTwitterLine,
    baseUrl: "https://x.com/",
  },
  {
    key: "linkedin",
    label: "LinkedIn",
    icon: RiLinkedinLine,
    baseUrl: "https://linkedin.com/in/",
  },
  {
    key: "threads",
    label: "Threads",
    icon: RiThreadsLine,
    baseUrl: "https://threads.net/@",
  },
];

export function normalizeSocialUrl(platform, value) {
  const rawValue = typeof value === "string" ? value.trim() : "";
  if (!rawValue) return null;
  if (/^https?:\/\//i.test(rawValue)) return rawValue;

  const setting = SOCIAL_PLATFORMS.find((item) => item.key === platform);
  if (!setting) return null;

  return `${setting.baseUrl}${rawValue.replace(/^@+/, "")}`;
}

export function buildSocialLinks(socialConfig = {}, siteName = "") {
  return SOCIAL_PLATFORMS.flatMap((platform) => {
    const href = normalizeSocialUrl(platform.key, socialConfig?.[platform.key]);
    if (!href) return [];

    return [
      {
        platform: platform.key,
        href,
        label: siteName ? `${siteName} ${platform.label}` : platform.label,
        icon: platform.icon,
      },
    ];
  });
}
